import React from 'react';
import { Modal, Table } from 'semantic-ui-react';
import './styles.scss';
import Button from '../../../../components/Button';

const TableHeading = () => (
    <Table.Header>
        <Table.Row>
            <Table.HeaderCell width='one'>Name</Table.HeaderCell>
            <Table.HeaderCell width='one'>Email</Table.HeaderCell>
            <Table.HeaderCell width='one'>Type</Table.HeaderCell>
            <Table.HeaderCell width='one'>Organisation</Table.HeaderCell>
            <Table.HeaderCell width='one'>Status</Table.HeaderCell>
            <Table.HeaderCell width='one'>Reason</Table.HeaderCell>
        </Table.Row>
    </Table.Header>
)

const TableItem = ({ data }) => (
    <Table.Row>
        <Table.Cell>
            {data.name}
        </Table.Cell>
        <Table.Cell>
            {data.email}
        </Table.Cell>
        <Table.Cell>
            {data.type == 2 ? 'consultant' : 'direct'}
        </Table.Cell>
        <Table.Cell>
            {data.organisation}
        </Table.Cell>
        <Table.Cell>
            {data.skipped ? 'FAILED' : 'SUCCESS'}
        </Table.Cell>
        <Table.Cell>
            {data.skipReason ? data.skipReason : '-'}
        </Table.Cell>
    </Table.Row>
);

const ResponseModal = ({ show, onClose, data = [] }) => {
  return (
      <Modal
      className='response-modal'
      open={show}
      onClose={onClose}
    >
          <Modal.Header>
            Registered Recruiters List
          </Modal.Header>
          <Modal.Content>
              <Table className='response-table'>
                  <TableHeading />
                  {data.length > 0 && data.map((r) => (
                      <TableItem data={r} />
                ))}
              </Table>
          </Modal.Content>
      </Modal>
  );
};

export default ResponseModal;